import {
  RegistrationTermsInformationSignComponent
} from '../registration-terms-information-sign/registration-terms-information-sign.component';
import { DigitalComponent } from '../digital/digital.component';
import { RulesAndFormOfPaymentComponent } from '../rules-and-form-of-payment/rules-and-form-of-payment.component';
import { ScontractComponent } from '../scontract/scontract.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { CoreModule } from 'src/app/core/core.module';
import { NotifyModule } from './home/home-enterprise/notify/notify.module';
import { HomeEnterpriseModule } from './home/home-enterprise/home-enterprise.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FooterComponent } from 'src/app/shared/components/footer/footer.component';
import { HeaderComponent } from 'src/app/shared/components/header/enterprise-header/header.component';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { NavigationComponent } from '../navigation/navigation.component';
import { AlertComponent } from 'src/app/shared/components/alert/alert.component';
import { TranslateModule } from '@ngx-translate/core';
import { ViewPdfComponent } from 'src/app/shared/components/view-pdf/view-pdf.component';
import {
  EnterpriseSidebarComponent
} from 'src/app/shared/components/sidebar/enterprise-sidebar/enterprise-sidebar.component';
import { HeaderSidebarComponent } from 'src/app/shared/components/sidebar/header-sidebar/header-sidebar.component';
import { FileAttachComponent } from 'src/app/shared/components/file-attach/file-attach.component';
import { MaterialModule } from 'src/app/core/material';
import { LoginEnterpriseComponent } from '../login/login-enterprise/login-enterprise.component';
import { ConfirmSignOtpComponent } from './home/home-enterprise/document/confirm-sign-otp/confirm-sign-otp.component';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { ListPhoneOtpComponent } from './home/home-enterprise/document/list-phone-otp/list-phone-otp.component';
import { HomeComponent } from 'src/app/modules/home/home.component';
import { ImportCustomerFileComponent } from '../../shared/components/ImportCustomerFile/import-customer-file.component';
import { LandingpageComponent } from '../landingpage/landingpage.component';
import { FirstPageComponent } from '../first-page/first-page.component';
import { KycEnterpriseModule } from '../kyc/kyc-enterprise.module';
import {
  RegistrationTermsInformationSignAnonymousComponent
} from '../registration-terms-information-sign-anonymous/registration-terms-information-sign-anonymous.component';
import { ProcedureManagementModule } from "./home/home-enterprise/procedure-management/procedure-management.module";
import { ImportUserFileComponent } from './../../shared/components/import-user-file/import-user-file.component';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { AlertEkycComponent } from 'src/app/shared/components/alert-ekyc/alert-ekyc.component';
import { WarningNotChangeContractCodeComponent } from 'src/app/shared/components/warning-not-change-contract-code/warning-not-change-contract-code.component';
import { NotifyWarningCustomComponent } from 'src/app/shared/components/notify-warning-custom/notify-warning-custom.component';
import { MultiDeleteDialogComponent } from './home/home-enterprise/document/search-document-mine/multi-delete-dialog/multi-delete-dialog.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { FileAttachMohaComponent } from 'src/app/shared/components/file-attach-moha/file-attach-moha.component';
import { LoginSsoVneidComponent } from '../login/login-sso-vneid/login-sso-vneid.component';
@NgModule({
  declarations: [
    NavigationComponent,
    AlertComponent,
    ImportCustomerFileComponent,
    FileAttachComponent,
    FileAttachMohaComponent,
    LoginEnterpriseComponent,
    LoginSsoVneidComponent,
    ConfirmSignOtpComponent,
    ListPhoneOtpComponent,
    HomeComponent,
    ScontractComponent,
    // ServicePackagesComponent,
    RulesAndFormOfPaymentComponent,
    DigitalComponent,
    LandingpageComponent,
    FirstPageComponent,
    RegistrationTermsInformationSignComponent,
    RegistrationTermsInformationSignAnonymousComponent,
    ImportUserFileComponent
  ],
  imports: [
    ProcedureManagementModule,
    CommonModule,
    DashboardRoutingModule,
    CoreModule,
    FormsModule,
    NotifyModule,
    ReactiveFormsModule,
    HomeEnterpriseModule,
    SharedModule,
    TranslateModule,
    MaterialModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    KycEnterpriseModule,
    NzCheckboxModule,
    NgZorroAntdModule,
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    EnterpriseSidebarComponent,
    HeaderSidebarComponent,
  ],
  entryComponents: [
    WarningComponent,
    WarningNotChangeContractCodeComponent,
    AlertComponent,
    AlertEkycComponent,
    ImportCustomerFileComponent,
    ViewPdfComponent,
    FileAttachComponent,
    FileAttachMohaComponent,
    ConfirmSignOtpComponent,
    ListPhoneOtpComponent,
    ImportUserFileComponent,
    NotifyWarningCustomComponent,
    MultiDeleteDialogComponent,
  ],
  providers: [{
    provide: RECAPTCHA_SETTINGS,
    useValue: {
      siteKey: '6LcLjFcUAAAAAC7FZ46NrNPHe__iSotYYdCH8I7-',
    } as RecaptchaSettings,
  }]
})
export class DashboardModule {
}
